"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = exports.ButtonWrapper = exports.StyledButton = exports.StyledDialogContent = exports.StyledCloseIcon = exports.StyledDialog = exports.StyledTitle = void 0;
const button_1 = require("@pulse-web-ui/button");
const theme_1 = require("@pulse-web-ui/theme");
const dialog_1 = require("@reach/dialog");
require("@reach/utils/polymorphic");
exports.StyledTitle = theme_1.styled.div `
  ${theme_1.typography.pulsHead2.regular};
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 8px;
`;
exports.StyledDialog = (0, theme_1.styled)(dialog_1.DialogOverlay).withConfig({
    shouldForwardProp: (prop) => !['modalBgColor'].includes(prop),
}) `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: 1;
  background: ${({ theme, modalBgColor }) => {
    if (modalBgColor === 'light') {
        return theme.colors.surface.primary;
    }
    if (modalBgColor === 'black') {
        return `${theme.colors.neutral['100']}80`;
    }
    return theme.colors.surface.background;
}};
`;
exports.StyledCloseIcon = theme_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 16px;
  top: 24px;
  cursor: pointer;
  padding: 4px;
  background: ${({ theme }) => theme.colors.surface.background};
  border-radius: calc(${({ theme }) => theme.common.radius} * 4);
`;
exports.StyledDialogContent = (0, theme_1.styled)(dialog_1.DialogContent).withConfig({
    shouldForwardProp: (prop) => !['desktopWidth', 'noMargin'].includes(prop),
}) `
  width: auto;
  margin: ${({ noMargin }) => `${noMargin ? 0 : '10vh'} auto`};
  background: white;
  padding: 24px 16px;
  outline: none;
  border-radius: calc(${({ theme }) => theme.common.radius} * 6);
  position: relative;
  box-sizing: border-box;

  ${theme_1.media.desktop} {
    width: ${({ desktopWidth }) => desktopWidth ? `${desktopWidth}px` : '402px'};
    padding: 24px;
  }
`;
exports.StyledButton = (0, theme_1.styled)(button_1.Button) `
  ${theme_1.typography.medium18}
  box-sizing: border-box;
  width: 100%;

  ${theme_1.media.desktop} {
    ${({ fullWidth }) => (fullWidth ? 'width: 100%;' : 'width: auto;')}
  }
`;
exports.ButtonWrapper = theme_1.styled.div `
  width: 100%;
  padding-top: 24px;
`;
exports.Footer = theme_1.styled.div `
  ${theme_1.mixins.flex({ gap: 16, alignItems: 'center', justifyContent: 'center' })}
`;
